import { Component, computed, effect, inject } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { MenuItemService, UserStore } from '@shared/data';
import { Roles } from '@shared/util-auth';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss',
  standalone: false
})
export class HeaderComponent {
  private static readonly LIMIT_ONLY_ROLES = new Set<string>([Roles.LIO_FK_DZ_LIMIT_ADMIN, Roles.LIO_FK_DZ_LIMIT_READONLY]);

  currentDate = new Date();

  private titleService = inject(Title);
  private userStore = inject(UserStore);
  headerTitle = computed(() => (this.userStore.isCorporateMode() ? 'Liquidity Invest for Corporates' : 'LiquiditätOnline'));
  private menuItemService = inject(MenuItemService);
  items = this.menuItemService.items;

  protected isCorporateMode = this.userStore.isCorporateMode;
  protected showCustomerInclude = computed(() => this.userStore.roles().some((role) => !HeaderComponent.LIMIT_ONLY_ROLES.has(role)));

  constructor() {
    effect(() => {
      const title = this.userStore.isCorporateMode() ? 'LICo' : 'LiOn';
      this.titleService.setTitle(title);
    });
  }
}
